
const projects = (state = {}, action) => {
  switch (action.type) {
    case 'PUBLIC_PROJECT_DETAILS':
      return {
        ...state,
        ...action.payload
      };
    case 'CREATE_AUDITION':
    	return {
    		...state,
    		...action.payload,
    		hasAudition: true
    		// ...action.payload
    	}
    case 'GET_AUDITION_EVENTS':
      return {
        ...state,
        auditionEvents: action.payload
      }
    case 'GET_AUDITION_DATES':
      return {
        ...state,
        auditionDates: action.payload
      }
    case 'GET_ROOMS':
      return {
        ...state,
        available_rooms: action.payload
      }
    case 'COMPANY_LANDING_PAGE_NEW':
      return {
        projects: action.payload.projects
      }
    case 'LOAD_ROLE_MEDIA':
      return {
        media: action.payload.medium
      }
    case 'DASHBOARD_LOAD_PROJ':
      var arrProj = []
      action.payload[0].projects.map((item, idx) => {
        arrProj.push(item)
      })
      action.payload[1].projects.map((item, idx) => {
        arrProj.push(item)
      })
      console.log('reducer-project', arrProj)
      return {
        projects: arrProj
      }
    case 'PUBLIC_REGISTRATION_PAGE':
      return {
        ...state,
        project: action.payload[0].project,
        company: action.payload[1].company
      }
    default:
      return state;
  }
};

export default projects


// WEBPACK FOOTER //
// ./src/reducers/projects.js